import { LitElement, html, css } from 'lit';

export class SldsBaseElement extends LitElement {
  static styles = css`
    :host {
      display: none; /* Initially hide the component */
    }
    :host([slds-loaded]) {
      display: block; /* Show the component when slds-loaded attribute is set */
    }
  `;

  constructor() {
    super();
    this.sldsLoaded = false;
  }

  firstUpdated() {
    this.loadSldsStyles();
  }

  async loadSldsStyles() {
    if (!this.shadowRoot.querySelector('link[href="/main.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = '/main.css';
      this.shadowRoot.appendChild(link);

      await new Promise((resolve) => {
        link.onload = resolve;
      });
    }

    this.verifySldsLoaded();
  }

  loadGlobalStyles() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/main.css';
    return link;
  }

  verifySldsLoaded() {
    const testElement = document.createElement('div');
    testElement.classList.add('slds-button');
    this.shadowRoot.appendChild(testElement);

    const computedStyle = window.getComputedStyle(testElement);
    if (computedStyle.color == 'rgb(1, 118, 211)') {
      this.sldsLoaded = true;
      this.setAttribute('slds-loaded', ''); // Set slds-loaded attribute
      // Debugger if main-view is inherited from slds-base-element
    }
    else {
      this.sldsLoaded = false;
      setTimeout(() => {
        this.verifySldsLoaded();
      }, 100);
    }

    this.shadowRoot.removeChild(testElement);
  }
}